import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "message-video-wrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoadedVideo)
      ? (_openBlock(), _createElementBlock("video", {
          key: 0,
          class: _normalizeClass({ '--is-widget': _ctx.isWidget }),
          src: _ctx.videoLink,
          autoplay: "",
          controls: "",
          playsinline: "",
          "webkit-playsinline": ""
        }, null, 10, _hoisted_2))
      : (_openBlock(), _createElementBlock("iframe", {
          key: 1,
          class: _normalizeClass({ '--is-widget': _ctx.isWidget }),
          src: _ctx.videoLink,
          frameborder: "0",
          allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
          allowfullscreen: ""
        }, null, 10, _hoisted_3))
  ]))
}